import { Navigate } from "react-router";
import { storageConst } from "../utils/constants";

interface ProtectedRouteProps {
  element: JSX.Element;
}

const PublicRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const isAuthenticated = localStorage.getItem(storageConst.APPTOKEN);

  if (!isAuthenticated) {
    return element;
  } else {
    return <Navigate to="/" />;
  }
};

export default PublicRoute;
